import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, Validators, FormsModule, ReactiveFormsModule, FormGroup, AbstractControl, ValidationErrors } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Roles } from '../../models/commonmodel';
import { ThemeserviceService } from '../theme/themeservice.service';
import { MemberInsurerRestService } from '../../services/member-insurer-rest.service';
// import { console } from 'node:inspector/promises';
import { NotificationService } from '../shared/services/notifications.service';
import { Router } from '@angular/router';
import {decode} from 'js-base64'
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
// import { console } from 'inspector';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [CommonModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, FormsModule,MatIconModule,MatButtonModule],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
onKeyDown($event: KeyboardEvent) {
if($event.key=='Enter'&&this.resetPassword.valid){

  this.onReset();
}
}
onEnterPressed($event: MouseEvent) {
  console.log($event)

}
  resetPassword: FormGroup<any>;
  // emailvalid:FormGroup<any>;
  apicall:boolean=false;
  userNameValid: boolean = false;
  passwordmatch: boolean = true;
  loginroute: string = "";
  resetcall:boolean=false;
  showPassword = false;
  showPasswordConfirm = false;
  role: string = 'PROVIDER';
  sessionMail:string='';

  
  verifyplayload: any = { usernameOrEmail: '', role: '' }
  resetpasswordplayload: any = { usernameOrEmail: '', password: '', role: '' }
  passwordChanged: boolean = false; // it should be handled by the api call based on respon from backend team
  constructor(private fb: FormBuilder, private http: HttpClient, private route: ActivatedRoute, private theme: ThemeserviceService, private restservice: MemberInsurerRestService, private notificationservice: NotificationService, private router: Router) {
   
    this.resetPassword = this.fb.group({
      username: ['', [Validators.required,Validators.email,Validators.pattern(/^[a-zA-Z0-9._%+-]+@healthfirsttech\.com$/)]],
      // Validators.pattern(/^[a-zA-Z0-9._%+-]+@healthfirsttech\.com$/)
       
      role: ['', Validators.required],
      password: ['', Validators.required,],
      reenterPassword: ['', Validators.required],
      
      
    },{
      validator: this.passwordMatchValidator('password', 'reenterPassword')
    })
    

    
     console.log(this.resetPassword.value.username)
    
    const url :any []=this.route.snapshot.url;
    console.log(url[1].path)
    if (url[1].path == 'provider') {
      
      this.role = 'PROVIDER';
      
      this.resetPassword.patchValue({role:this.role});
      this.loginroute=url[1].path;
      this.theme.applyTheme(this.role)
      
      
    }
    else if (url[1].path == 'insurer') {
      this.role = 'INSURER'
      
     
      this.resetPassword.patchValue({role:this.role});
       this.loginroute=url[1].path;
      this.theme.applyTheme(this.role)
      
    }
    else if(url[1].path=='distributor'){
      this.role='DISTRIBUTOR';
      this.resetPassword.patchValue({role:this.role})
      this.loginroute=url[1].path;
    }
    else if(url[1].path==='admininsurer'){
      this.role='ADMIN_INSURER';
       this.resetPassword.patchValue({role:this.role});
        this.loginroute='adminInsurer';
    }
    else if(url[1].path==='adminprovider'){
      this.role='ADMIN_PROVIDER';
       this.resetPassword.patchValue({role:this.role});
        this.loginroute='adminProvider';
    }
    else if(url[1].path==='admindistributor'){
      this.role='ADMIN_DISTRIBUTOR';
      this.resetPassword.patchValue({role:this.role});
      this.loginroute='adminDistributor';
    }
    
     
    
      
    
    
    
    
    
    
    
  }

  emailencrypted(email:string){

    const decoded= this.route.snapshot.queryParams;
    console.log(decoded['email']);
    console.log( decode(decoded['email']));
    this.resetPassword.patchValue({username:email});
    console.log(this.resetPassword)
  
    console.log(this.resetPassword.get('username')?.status=='VALID')
    console.log(decoded);
   console.log( this.resetPassword.value)
   
    
  

    if(decoded){
      
      this.verifyplayload.role = this.resetPassword.value.role;
        this.verifyplayload.usernameOrEmail =this.resetPassword.value.username;
        
        
         this.restservice.emailValidation(this.verifyplayload).subscribe({
              next:(response)=>{
                  if(response.success){
                   
                     this.userNameValid=true;
                    //  this.resetPassword.get("username")?.disable();
                    
    
                      
                     
                     
                      this.notificationservice.showNotification(response.message)
            }
            
          }
          // if (values.success) {
            //   this.userNameValid = true;
            
            // }
          })

    }

  }

  emailentry(){
    
     this.resetPassword.valueChanges.subscribe((value) => {
           
        // console.log(this.resetPassword.value);
        

        this.verifyplayload.role = this.resetPassword.value.role;
      //           const capital= this.resetPassword.value.username
      // //   console.log(capital.charAt(0).toUpperCase()+ capital)
      // // console.log(this.resetPassword.value.username)
      // this.resetPassword.value.username=capital.charAt(0).toUpperCase()+capital.slice(1,2).toLowerCase();
         this.verifyplayload.usernameOrEmail = this.resetPassword.value.username;
         console.log(this.verifyplayload.usernameOrEmail)
        this.apicall=this.resetPassword.get('username')?.status=='VALID';
       
        
        
        console.log(this.apicall)
      
        
       console.log( "the boolean is" +this.apicall)
       
      
        if (this.apicall) {
        
           this.restservice.emailValidation(this.verifyplayload).subscribe({
              next:(response)=>{
                  if(response.success){
                      this.userNameValid=true;
                      // this.resetPassword.get('username')?.disable();
                      this.notificationservice.showNotification(response.message)
            }
            
          }
          // if (values.success) {
            //   this.userNameValid = true;
            
            // }
          })


        }
         })
       
        
  }
  
 
  
 ngOnInit()  {

  

  console.log( "the password is" + this.resetPassword.get('password')?.value)

  

  const condition =this.route.snapshot.queryParams;
    if(condition['email']===undefined){
      this.emailentry();
    }
    else{
      const  encryptedemail=decode( condition['email'])

      this.emailencrypted(encryptedemail);
    }




  
   
     
    }


     passwordMatchValidator(controlName: string, matchingControlName: string): (formGroup: AbstractControl) => ValidationErrors | null {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const passwordControl = formGroup.get(controlName);
      const confirmPasswordControl = formGroup.get(matchingControlName);

      if (!passwordControl || !confirmPasswordControl) {
        return null; // Controls not found
      }

      // If confirmPasswordControl already has other errors, don't overwrite them unless it's our error
      if (confirmPasswordControl.errors && !confirmPasswordControl.errors['passwordMismatch']) {
        return null;
      }

      if (passwordControl.value !== confirmPasswordControl.value) {
        confirmPasswordControl.setErrors({ passwordMismatch: true });
        return { passwordMismatch: true }; // Also return error at form group level
      } else {
        confirmPasswordControl.setErrors(null); // Clear the error if they match
        return null;
      }
    };
  }

    
    onRouteToLogin() {
    this.router.navigate([`/login/${this.loginroute}`])
    }

    togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
    
  //   onReset() {
  //     console.log(this.userNameValid)
  //     if (this.userNameValid) {
  //       this.resetpasswordplayload.usernameOrEmail = this.resetPassword.value.username;
       
  //       this.resetpasswordplayload.password = this.resetPassword.value.password;
  //       this.resetpasswordplayload.role = this.resetPassword.value.role;
  //       console.log(this.resetpasswordplayload);
  //       // if (this.resetPassword.value.passowrd === this.resetPassword.value.reenterPassword)
        
  //       this.restservice.resetPassword(this.resetpasswordplayload).subscribe({
  //         next:(response)=>{
  //           if(response.success){
  //             this.userNameValid=false;
  //             this.passwordChanged=true;
  //             this.loginroute=response.role;
  //             this.loginroute= this.loginroute.toLowerCase()  ;
  //             console.log(this.loginroute)
    
  //             this.notificationservice.showNotification(response.message);

  // resetpassword(playload:any){

  //   console.log(playload)

  // }
 
  togglePasswordVisibilityConfirm() {
    this.showPasswordConfirm = !this.showPasswordConfirm;
  }

  onReset() {

    if(this.resetPassword.get('reenterPassword')?.value === this.resetPassword.get('password')?.value )
      {

        
      }

      else{
        this.passwordmatch=true;
      }
    console.log("reset method started");
    // this.resetpassword()
    this.resetcall=true;
    console.log(this.sessionMail)
    console.log(this.resetpasswordplayload)
     this.resetpasswordplayload.usernameOrEmail=this.resetPassword.value.username;
     this.resetpasswordplayload.password=this.resetPassword.value.password;
     this.resetpasswordplayload.role=this.resetPassword.value.role;

    if(this.userNameValid){
     
      this.restservice.resetPassword(this.resetpasswordplayload).subscribe({
        next:(value)=>{
          if(value.success){
            this.notificationservice.showNotification(value.message);
            this.passwordChanged=true;

          }
        }
      }
        
      )

    
    }
  
    console.log(this.resetPassword.value.username)
    
     
      // this.resetpasswordplayload.usernameOrEmail=this.resetPassword.value.username;
      // console.log(this.resetpasswordplayload.usernameOrEmail)
      // this.resetpasswordplayload.password = this.resetPassword.value.password;
      // this.resetpasswordplayload.role = this.resetPassword.value.role;
      // console.log(this.resetpasswordplayload);
      // if (this.resetPassword.value.passowrd === this.resetPassword.value.reenterPassword)

      // this.restservice.resetPassword(this.resetpasswordplayload).subscribe({
      //   next: (response) => {
      //     if (response.success) {
      //       this.userNameValid = false;
      //       this.passwordChanged = true;
      //       this.loginroute = response.role;
      //       this.loginroute = this.loginroute.toLowerCase();
      //       console.log(this.loginroute)

      //       this.notificationservice.showNotification(response.message);

      //       // this.router.navigate(["/login/provider"]);


      //     }

      //   }

      // })
    
  
  }
}
